import { Separator, H4 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getLastPathElement } from '../../../util/StringUtil'
import { MrnLink } from '../../app/Links'
import DmcDataView from '../../common/DmcDataView'

export default function OwsDeletedInfo({ deletedDate, deleteChanges }) {
  const { t } = useTranslation()
  if (!deletedDate && (!deleteChanges || deleteChanges.length === 0)) {
    return null
  }

  return (
    <>
      <H4 size="H5" supplementary>
        {t('ows.deletedInfo.deletedOws', 'Deleted OWS')}
      </H4>
      {deleteChanges.map((deleteChange) => {
        const data = [
          {
            label: t('ows.deletedInfo.deletedDate', 'Deleted Date'),
            detail: deletedDate?.original,
            key: 'deleted-date',
          },
          {
            label: t('reasonType', 'Reason Type'),
            detail: getLastPathElement(deleteChange.reasonType),
            key: 'reason-type',
          },
          {
            label: t('ows.deletedInfo.reasonDescription', 'Reason Description'),
            detail: deleteChange.reasonText,
            key: 'reason-description',
          },
          {
            label: t('ows.deletedInfo.sourceSystemType', 'Source System Type'),
            detail: getLastPathElement(deleteChange.sourceSystemType),
            key: 'source-system-type',
          },
          {
            label: t('ows.deletedInfo.sourceTempleId', 'Source Temple ID'),
            detail: deleteChange.sourceTempleId,
            key: 'source-temple-id',
          },
          {
            label: t('ows.deletedInfo.sourceWhoUSysId', 'Source Who USys ID'),
            detail: <MrnLink mrn={deleteChange.sourceWhoMrn} newTab />,
            key: 'source-who-usys-id',
          },
        ]
        return <DmcDataView key={`delete-change-${deleteChange.osid}`} data={data} />
      })}
      <Separator />
    </>
  )
}
